import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import ja from 'vuetify/src/locale/ja';
import 'material-design-icons-iconfont/dist/material-design-icons.css';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: '#3F51B5',
                secondary: '#7986CB',
                accent: '#82B1FF',
                error: '#FF5252',
                info: '#2196F3',
                success: '#4CAF50',
                warning: '#FFC107',
                tableHeader: '#F5F5F5',
                tooltip: '#9E9E9E'
            }
        }
    },
    lang: {
        locales: { ja },
        current: 'ja'
    },
    icons: {
        iconfont: 'mdi'
    }
});
